import { PrintLabel, PrintLogo } from "@/components/print/print-primitives.tsx";
import { Stack, Text } from "@skailer-com/uikit";
import { ReactNode } from "react";

interface PrintFooterProps {
  label: ReactNode;
  pageMarker: ReactNode;
}

export function PrintFooter({ label, pageMarker }: PrintFooterProps) {
  return (
    <Stack
      direction="horizontal"
      justify="between"
      items="end"
      gap="lg"
      className="print-doc-screen-footer mt-auto border-t border-dark-10 pt-6"
    >
      <Stack direction="horizontal" items="center" gap="sm">
        <PrintLogo className="h-5 w-5" />
        <Text className="text-base text-title">{label}</Text>
      </Stack>
      <PrintLabel tone="faint">{pageMarker}</PrintLabel>
    </Stack>
  );
}
